export enum HttpErrors {
  'internalServerError' = 500,
  'notFound' = 404,
  'forbidden' = 403,
  'unauthorized' = 401,
}
